import React from 'react';
import { CalendarDays, ExternalLink, MessageCircle, ShieldCheck, Zap } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function WsjPedidosPremiumCta({ copy, demoUrl, onWhatsapp }) {
  return (
    <section
      id="wsj-pedidos-cta"
      className="max-w-5xl mx-auto mb-16 sm:mb-20 scroll-mt-28 relative rounded-[2rem] border border-white/[0.08] overflow-hidden shadow-[0_40px_120px_-48px_rgba(212,165,116,0.28)]"
    >
      <div
        className="absolute inset-0 bg-gradient-to-br from-amber-500/[0.14] via-slate-950/95 to-slate-950 pointer-events-none"
        aria-hidden
      />
      <div className="absolute top-0 right-0 w-[min(100%,420px)] h-[280px] bg-emerald-500/[0.07] rounded-full blur-[100px] pointer-events-none" aria-hidden />
      <div className="absolute bottom-0 left-0 w-[min(100%,380px)] h-[240px] bg-amber-500/[0.08] rounded-full blur-[90px] pointer-events-none" aria-hidden />

      <div className="relative px-6 py-10 sm:px-12 sm:py-14 lg:px-16 lg:py-16 text-center">
        <h2 className="text-2xl sm:text-4xl lg:text-[2.35rem] font-black text-white tracking-tight mb-4 max-w-3xl mx-auto leading-tight break-words px-1">
          {copy.finalCtaTitle}
        </h2>
        <p className="text-white/55 font-light mb-10 max-w-2xl mx-auto leading-relaxed text-base sm:text-lg break-words px-1">{copy.finalCtaSubtitle}</p>

        <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4 mb-10">
          <Button
            asChild
            size="lg"
            className="rounded-xl bg-gradient-to-r from-amber-500 to-amber-600 text-slate-950 font-bold px-8 h-12 shadow-lg shadow-amber-900/25"
          >
            <a href={demoUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2">
              <CalendarDays className="w-4 h-4 shrink-0" aria-hidden />
              {copy.finalCtaScheduleDemo}
              <ExternalLink className="w-4 h-4 shrink-0" aria-hidden />
            </a>
          </Button>
          <Button
            type="button"
            size="lg"
            variant="outline"
            className="rounded-xl border-emerald-500/40 bg-emerald-500/10 text-emerald-50 hover:bg-emerald-500/18 h-12 px-8 font-semibold"
            onClick={onWhatsapp}
          >
            <MessageCircle className="w-4 h-4 mr-2 shrink-0" aria-hidden />
            {copy.finalCtaWhatsapp}
          </Button>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4 text-xs sm:text-sm">
          <span className="inline-flex max-w-full min-w-0 items-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-3 py-2 text-white/75 sm:px-4 break-words">
            <ShieldCheck className="w-4 h-4 shrink-0 text-emerald-400/90" aria-hidden />
            {copy.trustNoContract}
          </span>
          <span className="inline-flex max-w-full min-w-0 items-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-3 py-2 text-white/75 sm:px-4 break-words">
            <Zap className="w-4 h-4 shrink-0 text-amber-400/90" aria-hidden />
            {copy.trustFastSetup}
          </span>
          <span className="inline-flex max-w-full min-w-0 items-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-3 py-2 text-white/75 sm:px-4 break-words">
            <MessageCircle className="w-4 h-4 shrink-0 text-emerald-400/90" aria-hidden />
            {copy.trustSupportRegions}
          </span>
        </div>
      </div>
    </section>
  );
}
